// src/components/GeminiChatPage.js

import React from 'react';
// 🚨 Import de la traduction
import { useTranslation } from 'react-i18next'; 
// 🛑 Utiliser l'importation de votre composant non-renommé
import AIChat from './AIChat'; // Assurez-vous que le chemin './' est correct
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot } from '@fortawesome/free-solid-svg-icons';

const GeminiChatPage = () => {
    // 🛑 Initialisation du hook de traduction
    const { t } = useTranslation(); 
    
    // AUCUNE LOGIQUE API ICI

    return (
        <div className="container mt-4">
            <div className="row justify-content-center">
                <div className="col-md-8 col-lg-6">
                    <div className="chat-page-container shadow mb-4">
                        
                        <div className="chat-header">
                            <FontAwesomeIcon icon={faRobot} className="me-2" />
                            {/* 🛑 UTILISER LA TRADUCTION POUR LE TITRE */}
                            {t('ai_assistant_title', 'Assistant IA Gemini Blackroq')}
                        </div>
                        
                        {/* 🛑 Rendre le composant sans prop onSendMessage */}
                        <AIChat /> 

                    </div>
                </div>
            </div>
        </div>
    );
};

export default GeminiChatPage;